import { isObject } from "@atlassiansox/bxp-shared-utils";

export type ImageType = "image" | "gradient";

export function isImageType(value: string): value is ImageType {
    return ["image", "gradient"].includes(value);
}

export type Angle = 0 | 60 | 90 | 120 | 180 | 240 | 270 | 300;

export function isAngle(value: number): value is Angle {
    return [0, 60, 90, 120, 180, 240, 270, 300].includes(value);
}

export type Image = {
    type: ImageType;
    image: {
        id: string;
        value: string;
    };
    gradient: {
        value: string;
        angle: Angle;
    };
};

export function isImage(value: unknown): value is Image {
    if (!isObject(value)) {
        return false;
    }
    const temp = value as Image;

    return (
        isImageType(temp.type) &&
        isObject(temp.image) &&
        typeof temp.image.id === "string" &&
        typeof temp.image.value === "string" &&
        isObject(temp.gradient) &&
        typeof temp.gradient.value === "string" &&
        isAngle(temp.gradient.angle)
    );
}
